import styled from '@emotion/styled'
import {
  NewFlexContainer,
  NewFlexContainerProps
} from 'components/common/common.style'
import { unifiedColors } from 'styles/colors'
import { theme, themeUtils } from 'styles/theme'

export const FakeLink = styled.p`
  ${themeUtils.bodyXSmall}
  display: inline;
  color: ${theme.palette.label.default};
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    ${themeUtils.minWidth.md} {
      text-decoration-thickness: 1.5px;
    }
  }
`

export const FooterContainer = styled.footer`
  &:before {
    content: '';
    display: block;
    height: 125px;
    width: 100%;
    margin-top: -125px;
    background: linear-gradient(
      to bottom,
      ${unifiedColors.surface.secondary},
      ${unifiedColors.surface.secondary}
    );
    border-bottom-left-radius: 120px;
    border-bottom-right-radius: 120px;
    ${themeUtils.maxWidth.md} {
      margin-top: -32px;
      height: 48px;
    }
  }
  margin-bottom: 80px;
  background-color: ${unifiedColors.surface.purple};
`

export const FooterContent = styled((props: NewFlexContainerProps) => (
  <NewFlexContainer
    margin="101px auto"
    flexDirection="column"
    gap="32px"
    {...props}
  />
))`
  max-width: 1440px;
  padding-bottom: 80px;
  ${themeUtils.maxWidth.md} {
    margin-top: 48px;
    gap: 16px;
    padding-bottom: 32px;
  }
`
